﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {ErrorMessage, RemoteDataStatus, useRemoteData} from "@2d-front-monorepo/design-library";
import {PermitId, Permits, Residencies, ResidencyId} from "@2d-front-monorepo/permits-business";

import {JSX} from "react";
import {useSearchParams} from "react-router";
import PermitsInlineLoading from "../../components/PermitsInlineLoading";
import Registrations from "../../customers/Registrations";
import {getHttpClient} from "../../hooks/getHttpClient";
import {usePermits} from "../../hooks/usePermits";

export default function CreateResidency(): JSX.Element {
	const [searchParams] = useSearchParams();
	const permitsState = usePermits();
	const {holderData} = permitsState;

	const permitId = searchParams.get("permitId") as PermitId;
	const residencyId = searchParams.get("residencyId") as ResidencyId;

	const permit = isNullOrEmpty(permitId) ? undefined : Permits.find(permitsState, permitId);
	const residency = isNullOrEmpty(residencyId) ? undefined : Residencies.get(permitsState, residencyId);
	const {data, status, error} = useRemoteData(() => {
		if (permitId == null || residencyId == null) {
			return Promise.resolve(undefined);
		}

		return getHttpClient().permits.getResidencyBehavior(permitId, residencyId);
	}, [permitId, residencyId]);

	if (status === RemoteDataStatus.Loading) {
		return <PermitsInlineLoading/>;
	}

	if (status === RemoteDataStatus.Error) {
		return <ErrorMessage error={error}/>;
	}

	const EditComponent = Registrations.getCreateResidency();
	return <EditComponent holderData={holderData} permits={permitsState} holder={permitsState} permit={permit} residency={residency} behavior={data}/>;
}
